import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, HostListener, Inject, Input, OnInit, PLATFORM_ID, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { VhImage, VhQueryAutoWeb } from 'vhautowebdb';
import { LanguageService } from 'vhobjects-service';
import {
  ChooseImageComponent,
  ManageLibraryComponent,
} from 'vhobjects-service';
import { FunctionService } from 'vhobjects-service';

@Component({
  selector: 'app-flip-book-admin',
  templateUrl: './flip-book-admin.component.html',
  styleUrls: ['./flip-book-admin.component.scss'],
})
export class AtwFlipBookAdmin implements OnInit {
  @Input() objectChoosing: any;
  @Input() type: any;
  @Input() device: any;
  @Input() staticdata: any;

  /** Lấy reference đến thẻ bao quanh danh sách ảnh */
  @ViewChild('scrollList') scrollList!: ElementRef;

  dataImages: any = [];
  dataLoaded: boolean;
  tabChoosing: any = {}; // Biến dùng để lưu tab đang được chọn
  compressWidth: number = 100;
  compressHeight: number = 100;
  resolution = null;
  path = '';
  isShowConfirmPopup: boolean = false;
  isConfirmLoading: boolean = false; // biến kiểm tra khi đang xử lý dữ liệu
  id_subproject: any;
  subproject = null;
  toggleInputLinkImg: boolean = false;
  newUrlImage: string = '';
  iconAddImage = {
    device: 'vertical_align_top',
    library: 'image',
    url: 'link',
    free_img: 'cloud_upload',
  };

  previewUrl: string | null = null;
  dragging = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private matdialog: MatDialog,
    private dialog: MatDialog,
    public functionService: FunctionService,
    private languageService: LanguageService,
    private vhImage: VhImage,
  ) {}

  ngOnInit(): void {
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
    this.subproject = this.vhQueryAutoWeb.getlocalSubProject(
      this.vhQueryAutoWeb.getlocalSubProject_Working()._id
    );
    this.resolution = this.subproject.resolution;

    this.getData();
  }

  /**
   * Lấy data để thực hiện kéo thả và load danh sách hình ảnh
   * @returns
   */
  getData() {
    if (this.dataLoaded) return; // Nếu dữ liệu đã được tải, không gọi API nữa
    this.dataImages = this.staticdata.img[this.device + '_imgs'];
    this.dataLoaded = true;
  }

  /**
   * Hàm thực hiện việc thay đổi vị trí của các hình ảnh trong danh sách
   * @param event
   */
  cdkDropListDropped(event: CdkDragDrop<any[]>) {
    if (event.previousIndex === event.currentIndex) return;
    // moveItemInArray(this.dataImages, event.previousIndex, event.currentIndex);
    const arr = [...this.dataImages];
    const item = arr.splice(event.previousIndex, 1)[0];
    arr.splice(event.currentIndex, 0, item);
    this.dataImages = arr;

    if (this.objectChoosing.setups.upload_image.display == 'shared') {
      this.functionService.devices.forEach((device) => {
        this.staticdata.img[device.value + '_imgs'] = this.dataImages;
      });
    } else {
      this.staticdata.img[this.device + '_imgs'] = this.dataImages;
    }

    this.updateStaticData();
  }

  /**
   * Xoá hình ảnh với vị trí truyền vào
   * @param index vị trí hình ảnh trong danh sách
   */
  removeImage(index: number) {
    if (this.objectChoosing.setups.upload_image.display == 'shared') {
      this.functionService.devices.forEach((device) => {
        this.staticdata.img[device.value + '_imgs'].splice(index, 1);
      });
    } else {
      this.staticdata.img[this.device + '_imgs'].splice(index, 1);
    }

    this.updateStaticData(); // Gọi lại sau khi xoá
  }

  /**
   * Thêm hình ảnh mới
   */
  addImage() {
    switch (this.objectChoosing.setups.upload_image.source) {
      case 'device':
        this.openUpload();
        break;
      case 'library':
        this.openLibrary();
        break;
      case 'url':
        this.toggleInputLinkImg = true;
        break;
      case 'free_img':
        this.openDialogChooseImage();
        break;
    }
    // this.updateStaticData(); // Gọi lại sau khi thêm
  }

  /**
   * Thay đổi loại hình ảnh: dùng chung ảnh cho các thiet bi, dùng rieng ảnh cho tung thiet bi
   */
  changeImgType() {
    // nếu đối imgType thành dùng chung ảnh cho từng thiết bị thì lưu ảnh của thiết bị có width lớn nhất vào các thiết bị còn lại
    if (this.objectChoosing.setups.upload_image.display == 'shared') {
      this.functionService.devices.forEach((device) => {
        this.staticdata.img[device.value + '_img'] =
          this.staticdata.img[this.device + '_img'];
      });
    }
    this.updateStaticData();
    this.updateSetups();
  }

  /** UPLOAD IMAGE */
  openUpload() {
    if (isPlatformBrowser(this.platformId))
      document.getElementById('upload').click();
    // inputVal;
  }
  /**
   * Hành động tải tệp lên
   */
  onUpload(e) {
    const file = e.target.files[0];
    const input = e.target as HTMLInputElement;

    if (file && file.type.startsWith('image/')) {
      this.processImageUpload(file);
    } else {
      if (!file.type.startsWith('image/')) {
        this.functionService.createMessage('warning', 'vui_long_chon_tep_hinh_anh_hop_le');
        return;
      }
    }

    // Đặt lại giá trị của trường tệp để kích hoạt sự kiện change lần sau
    input.value = '';
  }

  /**
   * Hàm xử lý khi người dùng kéo và thả (drop) một tệp vào vùng upload.
   * @param event
   */
  onFileDropped_upload(event: DragEvent) {
    event.preventDefault();
    this.dragging = false;
    const file = event.dataTransfer?.files[0];

    if (file && file.type.startsWith('image/')) {
      // Hiển thị preview
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result as string;
      };
      reader.readAsDataURL(file);

      // Xử lý tệp hình ảnh
      this.processImageUpload(file);
    } else {
      if (!file.type.startsWith('image/')) {
        this.functionService.createMessage('warning', 'vui_long_keo_tep_hinh_anh_hop_le');
        return;
      }
    }
  }

  /**
   * Hành động khi người dùng kéo file qua vùng upload (chưa thả).
   * @param event 
   */
  onDragOver_upload(event: DragEvent) {
    event.preventDefault();
    this.dragging = true;
  }

  /**
   * Hành động khi người dùng rời con trỏ khỏi vùng upload mà chưa thả.
   */
  onDragLeave_upload() {
    this.dragging = false;
  }

  /**
   * Hàm xử lý tệp hình ảnh lên server 
   * - Tải lên
   * - Kéo thả vào
   * 
   * Nén ảnh:
   * - 'no-compress': Không nén ảnh sau khi tải lên
   * - 'compress-screen': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi thiết bị
   * - 'compress-frame': Nén ảnh sau khi tải lên, nén ảnh theo tỉ lệ màn hình của mỗi khung hình thiết bị
   * @param file File được kéo thả vào hoặc được tải lên
   */
  processImageUpload(file: File) {
    let compress_type = this.objectChoosing.setups.upload_image.compress_type;
  
    let resolution = {};
    switch (compress_type) {
      case 'compress-screen':
        resolution = {
          width: this.resolution[this.device + '_width'],
          height: 0,
        };
        break;
      case 'compress-frame':
        const dimension = this.objectChoosing[`${this.device}_config`]?.dimension;
        if (
          dimension && 
          Object.keys(dimension).length > 0 &&
          typeof dimension.width === 'number' &&
          typeof dimension.height === 'number'
        ) {
          resolution = {
            width: dimension.width,
            height: dimension.height,
          };
        }
        else {
          const deviceItem = this.functionService.devices.find((device) => device.value == this.device);
          resolution = {
            width: deviceItem.width,
            height: deviceItem.height,
          };
        }
        break;
      case 'custom':
        resolution = {
          width: +this.compressWidth,
          height: +this.compressHeight,
        };
        compress_type = 'compress-frame';
        break;
    }
  
    this.vhImage
      .getImageFromDesktop_Autoweb(file, 'images/design/objects', {
        compress_type: compress_type,
        resolution: resolution,
      })
      .then((res: any) => {
        if (res.vcode != 0) {
          this.functionService.createMessage('error', `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${res.msg}`);
          return;
        } else {
          this.functionService.createMessage('success', 'tai_anh_thanh_cong');
        }
  
        if (this.objectChoosing.setups.upload_image.display == 'shared') {
          this.functionService.devices.forEach((device) => {
            this.staticdata.img[device.value + '_imgs'].push(res.data);
          });
        } else {
          this.staticdata.img[this.device + '_imgs'].push(res.data);
        }
  
        this.updateStaticData();
      });
  }

  /**
   * Hàm xử lý lấy ảnh ở thư viện
   */
  openLibrary() {
    const dialogRef = this.matdialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path ? this.path : '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
        // nếu không thì lưu ảnh vào thiết bị đang chọn
        if (this.objectChoosing.setups.upload_image.display == 'shared') {
          this.functionService.devices.forEach((device) => {
            this.staticdata.img[device.value + '_imgs'].push(data.href);
          });
        } else {
          this.staticdata.img[this.device + '_imgs'].push(data.href);
        }

        this.updateStaticData();
      }
      this.path = data.path;
    });
  }

  /**
   * Hàm xử lý lấy url ảnh từ các nguồn khác
   */
  handleChangeUrlImage(e) {
    e?.stopPropagation();
    if (!this.newUrlImage) {
      this.functionService.createMessage('error', 'vui_long_nhap_link_anh');
      return;
    }

    if (this.objectChoosing.setups.upload_image.display == 'shared') {
      this.functionService.devices.forEach((device) => {
        this.staticdata.img[device.value + '_imgs'].push(this.newUrlImage);
      });
    } else {
      this.staticdata.img[this.device + '_imgs'].push(this.newUrlImage);
    }

    this.newUrlImage = '';
    this.updateStaticData();
    this.closePopover();
  }

  /**
   * Hàm đóng popover của input link ảnh
   */
  closePopover(e?) {
    e?.stopPropagation();
    this.toggleInputLinkImg = false;
  }

  /**
   * Hàm kiểm tra link trong danh sách ảnh có id_subproject hay không
   * - Nếu chỉ một item trong danh sách không có id_subproject hoặc nếu imgItem = null thì return false
   * (Để không cần phải thực hiện chuyển lên server)
   * - Còn lại nếu tất cả item trong danh sách đều có id_subproject thì return true
   */
  hasSomeImgNotIncludeIdSubproject(): boolean {
    const images = this.staticdata?.img?.[this.device + '_imgs'] || [];
    return images.some((imgItem) => {
      if (!imgItem) return false;
      return !imgItem.includes(this.id_subproject);
    });
  }

  /**
   * Hàm mở popup kho ảnh dùng chung
   */
  openDialogChooseImage() {
    const dialogRef = this.dialog.open(ChooseImageComponent, {
      width: '80vw',
      height: '90vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        // nếu là dùng chung ảnh thì lưu ảnh vào các thiết bị
        // nếu không thì lưu ảnh vào thiết bị đang chọn
        if (this.objectChoosing.setups.upload_image.display == 'shared') {
          this.functionService.devices.forEach((device) => {
            this.staticdata.img[device.value + '_imgs'].push(result);
          });
        } else {
          this.staticdata.img[this.device + '_imgs'].push(result);
        }

        this.updateStaticData();
        this.isShowConfirmPopup = true;
      }
    });
  }

  /**
   * Lấy hình ảnh từ url đẩy lên server với kích thước hình thay đổi
   * */
  async handleOkConfirm() {
    this.isConfirmLoading = true;

    let compress_type = this.objectChoosing.setups.upload_image.compress_type;

    let resolution = {};
    switch (this.objectChoosing.setups.upload_image.compress_type) {
      case 'compress-screen':
        resolution = {
          width: this.resolution[this.device + '_width'],
          height: 0,
        };
        break;
      case 'compress-frame':
        const dimension = this.objectChoosing[`${this.device}_config`]?.dimension;
        if (
          dimension && 
          Object.keys(dimension).length > 0 &&
          typeof dimension.width === 'number' &&
          typeof dimension.height === 'number'
        ) {
          resolution = {
            width: dimension.width,
            height: dimension.height,
          };
        }
        else {
          const deviceItem = this.functionService.devices.find((device) => device.value == this.device);
          resolution = {
            width: deviceItem.width,
            height: deviceItem.height,
          };
        }
        break;
      case 'custom':
        resolution = {
          width: +this.compressWidth,
          height: +this.compressHeight,
        };
        compress_type = 'compress-frame';
        break;
    }
    if (!this.staticdata.img?.[this.device + '_imgs']) return;

    const promises = this.staticdata.img[this.device + '_imgs'].map(
      (imageUrl, index) => {
        if (imageUrl.includes(this.id_subproject)) {
          return Promise.resolve(); // Bỏ qua ảnh đã chứa id_subproject
        }
        return this.vhImage
          .getImageFromURL_Autoweb(imageUrl, 'images/design/objects', {
            compress_type,
            resolution,
          })
          .then((rsp: any) => {
            if (rsp.vcode === 0) {
              if (
                this.objectChoosing.setups.upload_image.display === 'shared'
              ) {
                this.functionService.devices.forEach((device) => {
                  this.staticdata.img[device.value + '_imgs'][index] = rsp.data;
                });
              } else {
                this.staticdata.img[this.device + '_imgs'][index] = rsp.data;
              }
              this.updateStaticData();
              this.functionService.createMessage('success', 'tai_anh_thanh_cong');
            } else {
              this.functionService.createMessage('error', `${this.languageService.translate('tai_anh_that_bai_ly_do')}: ${rsp.msg}`);
            }
          })
          .catch((error: any) => {
            const errMsg = error?.message || '';
            if (errMsg.includes('413')) {
              this.functionService.createMessage(
                'error',
                this.languageService.translate(
                  'file_anh_qua_lon_vui_long_chon_file_anh_co_dung_luong_nho_hon'
                ) + ' 1Mb'
              );
            } else if (
              errMsg.includes('403') ||
              errMsg.includes('CORS') ||
              errMsg.includes('Failed to fetch') ||
              errMsg.includes('ERR') // generic fail
            ) {
              this.functionService.createMessage(
                'error',
                this.languageService.translate(
                  'anh_bi_chan_hoac_khong_truy_cap_duoc'
                ) +
                  ': ' +
                  imageUrl
              );
              console.warn(
                this.languageService.translate(
                  'anh_bi_chan_hoac_khong_truy_cap_duoc'
                ) + ':',
                error
              );
              // Bỏ qua ảnh lỗi, không thêm vào danh sách
            } else {
              this.functionService.createMessage(
                'error',
                this.languageService.translate('xu_ly_anh_khong_thanh_cong') +
                  ': ' +
                  imageUrl
              );
              console.error(
                this.languageService.translate('xu_ly_anh_khong_thanh_cong') +
                  ': ',
                error
              );
            }
          });
      }
    );

    await Promise.all(promises);
    setTimeout(() => {
      this.isConfirmLoading = false;
      this.isShowConfirmPopup = false;
    }, 300);
  }

  /**
   * Lấy ra tên file và đuôi file
   * @param url Đường dẫn ảnh
   * @example const { fileName, fileExtension } = getFileInfo("https://115.78.228.208:20350/autowebapp/67c1b593b1344364462b082b/images/design/objects/3-1-768x768%20(3).png");
   */
  getFileInfo(url: string) {
    const decodedUrl = decodeURIComponent(url);
    const parts = decodedUrl.split('/');
  
    // Lấy tên file (phần cuối)
    const fullFileName = parts.pop() || '';
    const dotIndex = fullFileName.lastIndexOf('.');
  
    // Tìm và lấy phần giữa (ví dụ: "images/design/objects")
    const indexImages = parts.indexOf('images');
    const folderPath =
      indexImages !== -1 ? parts.slice(indexImages).join('/') : '';
  
    return {
      fullFileName, // ví dụ: "3-1-768x768 (3).png"
      fileName: fullFileName.substring(0, dotIndex), // "3-1-768x768 (3)"
      fileExtension: fullFileName.substring(dotIndex + 1), // "png"
      folderPath, // "images/design/objects"
    };
  }

  /**
   * Sao chép đường dẫn hình ảnh vào bộ nhớ tạm
   * @param url Đường dẫn ảnh
   */
  copyLinkImg(url: string) {
    if (isPlatformBrowser(this.platformId)) {
      navigator.clipboard.writeText(url)
        .then(() => {
          this.functionService.createMessage('success', 'da_sao_chep_vao_bo_nho_tam', 2000);
        })
        .catch(err => {
          this.functionService.createMessage('error', 'loi_khi_sao_chep', 2000);
          console.error('❌ Lỗi khi copy:', err);
        });
    }
  }

  @HostListener('wheel', ['$event'])
  onMouseWheel(event: WheelEvent) {
    const container = this.scrollList.nativeElement;

    // Kiểm tra xem chuột có đang nằm trên vùng danh sách ảnh hay không
    // event.composedPath() trả về danh sách các thẻ mà sự kiện đi qua
    if (event.composedPath().includes(container)) {
      if (event.deltaY !== 0) {
        // Chặn cuộn dọc mặc định của trình duyệt
        event.preventDefault();
        
        // Chuyển hướng lăn chuột dọc thành cuộn ngang
        container.scrollLeft += event.deltaY;
      }
    }
  }

  /**
   * Cập nhật staticdata vào database.
   */
  updateStaticData() {
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes('staticdata')) this.objectChoosing['fieldUpdate'].push('staticdata')
      return;
    }
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      staticdata: this.staticdata,
    });
  }

  /**
   * Cập nhật Setups vào database.
   */
  updateSetups() {
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes('setups')) this.objectChoosing['fieldUpdate'].push('setups')
      return;
    }
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      setups: this.objectChoosing.setups,
    });
  }

  updateObject() {
    if (this.type == 'admin') {
      if (!this.objectChoosing.hasOwnProperty('fieldUpdate')) this.objectChoosing['fieldUpdate'] = []
      if (!this.functionService.objectsAndBlocksUpdated.some((ele) => ele._id == this.objectChoosing._id)) this.functionService.objectsAndBlocksUpdated.push(this.objectChoosing)
      if (!this.objectChoosing['fieldUpdate'].includes('staticdata')) this.objectChoosing['fieldUpdate'].push('staticdata')
      if (!this.objectChoosing['fieldUpdate'].includes('setups')) this.objectChoosing['fieldUpdate'].push('setups')
      return;
    }
    this.vhQueryAutoWeb.updateObject(this.objectChoosing._id, {
      staticdata: this.staticdata,
      setups: this.objectChoosing.setups,
    });
  }
}
